import { useEffect, useRef, useState } from 'react';
import { PER_PAGE_SIZE } from 'consts/transactions';
import { getPspKycSettings } from 'features/pspKycSettings/api';
import {
    selectPspKycSettings,
    selectPspKycSettingsSlice
} from 'features/pspKycSettings/selectors';
import {
    changePspKycSettingsLoadingState,
    changePspKycSettingsSlice
} from 'features/pspKycSettings/slice';
import { useTypedSelector } from 'hooks';
import useFetchFeatureResource from 'hooks/useFetchFeatureResource';

export default function useFetchPspKycSettings() {
    const isRequestsProcessingRef = useRef<boolean | undefined>();
    const [isLoading, setLoading] = useState(false);

    const getAllSettingsRef = useRef(
        useFetchFeatureResource({
            resourceRequest: (queryString?: string) => getPspKycSettings(queryString),
            changeLoadingState: changePspKycSettingsLoadingState,
            changeSlice: changePspKycSettingsSlice,
            shouldFetchAll: true,
            perPage: PER_PAGE_SIZE,
            condition: () => typeof isRequestsProcessingRef.current === "boolean"
        })
    );

    const sliceSnapshot = useTypedSelector(selectPspKycSettingsSlice);
    const settings = useTypedSelector(selectPspKycSettings);

    const getSettingsSlice = () => settings;

    useEffect(() => {
        if (sliceSnapshot || isRequestsProcessingRef.current) {
            return;
        }

        let processing = isRequestsProcessingRef.current = true;
        setLoading(processing);

        getAllSettingsRef.current()
            .finally(() => {
                processing = isRequestsProcessingRef.current = false;
                setLoading(processing);
            });
    }, [sliceSnapshot]);

    return {
        getSettingsSlice,
        isLoading
    };
}
